import React from "react";
import { Copy, Download, FileText } from "lucide-react";

export default function AttendanceDownloadMenu({
  handleDownloadExcel,
  handleShareStats,
  isOpen,
  setIsOpen,
  triggerClassName,
  triggerIconClassName,
}) {
  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={triggerClassName}
        title="다운로드 및 공유"
      >
        <Download size={18} className={triggerIconClassName} />
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)}></div>
          <div className="absolute right-0 top-14 bg-white border border-gray-100 shadow-xl rounded-[2rem] p-2 z-50 w-48 flex flex-col gap-1">
            <button
              onClick={() => {
                handleDownloadExcel();
                setIsOpen(false);
              }}
              className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 rounded-2xl text-sm font-bold text-gray-700 transition text-left"
            >
              <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center text-green-600"><FileText size={16} /></div>
              엑셀로 저장
            </button>
            <button
              onClick={() => {
                handleShareStats();
                setIsOpen(false);
              }}
              className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 rounded-2xl text-sm font-bold text-gray-700 transition text-left"
            >
              <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600"><Copy size={16} /></div>
              클립보드 복사
            </button>
          </div>
        </>
      )}
    </div>
  );
}
